import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { hasForcePasswordChangeFlag } from '../util/auth/helpers';
import { SuiteShellService } from '@services/suite-shell.service';
import { entradaTrasLogin } from '@services/suite-shell.logic';


@Injectable()
export class AuthGuard  {
  constructor(
    private _auth: AuthService,
    private router: Router,
    private permissionsService: NgxPermissionsService,
    private shell: SuiteShellService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (this._auth.loggedIn()) {

      const permissions = JSON.parse(localStorage.getItem('USER_PERMISSIONS'));

      if(permissions) {
        this.permissionsService.loadPermissions(permissions);
      }

      const path = state.url.split('?')[0];
      if (path === '/logout') {
        return true;
      }

      const mustChange = hasForcePasswordChangeFlag();
      const onChangePage = path === '/change-password';
      if (mustChange && !onChangePage) {
        return this.router.createUrlTree(['/change-password']);
      }
      if (!mustChange && onChangePage) {
        this.shell.reiniciarEnClasica();
        return this.router.createUrlTree([entradaTrasLogin()]);
      }

      return true;
    }  else {
      localStorage.removeItem('access_token');

      this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
      return false;
    }
  }
}
